import { Column } from "@ant-design/plots";

function GroupedColumn({ data, x, y, name }) {
  const config = {
    data,
    isGroup: true,
    xField: x,
    yField: y,
    seriesField: name,
    yAxis: {
      label: {
        formatter: (v) =>
          `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`) + `₮`,
      },
    },
    tooltip: {
      formatter: (datum) => {
        return {
          name: `${datum[name]}`,
          value:
            `${datum[y]}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`) +
            `₮`,
        };
      },
    },
    label: {
      position: "top",
      formatter: (v) =>
        `${v.amount}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`) + `₮`,
      layout: [
        {
          type: "interval-adjust-position",
        },
        {
          type: "interval-hide-overlap",
        },
        {
          type: "adjust-color",
        },
      ],
    },
    columnStyle: {
      radius: [15, 15, 0, 0],
    },
  };

  return <Column {...config} style={{ width: "100%" }} />;
}

export default GroupedColumn;
